export default "__VITE_ASSET__CrdlHVDb__"